import __pages_import_0__ from "/src/pages/index.vue";
import __pages_import_1__ from "/src/pages/indexation/[id].vue";

const routes = [{"name":"index","path":"/","component":__pages_import_0__,"props":true},{"name":"indexation-id","path":"/indexation/:id","component":__pages_import_1__,"props":true}];

export default routes;